<template>
  <!-- Kontener pojedynczego filtra: flexowy układ w wierszu -->
  <div class="filter">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę bez tłumaczenia -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora (np. '=', '>='), wyświetlany jeśli został przekazany jako props -->
    <span class="symbol">{{ symbol }}</span>
    <!-- Pole input wiązane dwukierunkowo z wartością filtra:
         - name odpowiada kluczowi w store.filters
         - v-model.lazy aktualizuje value po zdarzeniu 'change'
    -->
    <input
      :name="fieldName"
      v-model.lazy="value"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useCurrentFiltersStore } from "../../stores/currentFilters";
import { isNOSG } from "@/config/appVersion";

export default {
  name: "SingleFilter",
  props: ["name", "symbol", "fieldName"],

  setup(props) {
    const filtersStore = useCurrentFiltersStore();

    if (
      props.fieldName === "similarity" &&
      isNOSG &&
      (filtersStore.filters[props.fieldName] === undefined || filtersStore.filters[props.fieldName] === "")
    ) {
      filtersStore.addItem(props.fieldName, 1);
    }

    // v-model podpięty bezpośrednio do store — zapis jest synchroniczny.
    // Patrz komentarz w RangeFilter.vue: wcześniejsza implementacja z `ref` + `watch`
    // powodowała race condition z watcherem na current.step (pierwsze żądanie
    // w kroku 3 szło bez świeżo wprowadzonych filtrów).
    const value = computed({
      get: () => filtersStore.filters[props.fieldName] ?? "",
      set: (val) => filtersStore.addItem(props.fieldName, val),
    });

    return { value, filtersStore };
  },
};
</script>

<style scoped>
/* Wiersz filtra: etykieta — operator — pole. Wysokość i obramowanie pola
   pochodzą z design-system.css, tutaj tylko układ wiersza.

   Wiersz wpina się w siatkę kolumn `.vehicle-half--grid` (CurrentVehicleData.vue)
   przez `subgrid`, zamiast rozstawiać elementy własnym flexem. Tylko tak kolumna
   operatora ma tę samą szerokość co w wierszach zakresowych, a pole zaczyna się
   równo z polem „od" pod spodem. Odstępy kolumn dziedziczymy z rodzica. */
.filter {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  min-width: 0;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--border-subtle);
}

.filter:last-child {
  border-bottom: 0;
}

/* Operator porównania (=, >=) — dyskretny znacznik przy polu. Bez własnej
   szerokości: wyznacza ją wspólna kolumna siatki. */
.symbol {
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

/* Pole zajmuje wszystko od kolumny pierwszego pola do końca wiersza, czyli
   dokładnie obszar „pole od + operator do + pole do" z wierszy zakresowych. */
input {
  grid-column: 3 / -1;
  width: auto;
  min-width: 0;
  text-align: center;
  text-transform: uppercase;
}
</style>
